import { render } from "./Bill_information.vue?vue&type=template&id=6b1c4d46&scoped=true"
import script from "./Bill_information.vue?vue&type=script&lang=js"
export * from "./Bill_information.vue?vue&type=script&lang=js"

import "./Bill_information.vue?vue&type=style&index=0&id=6b1c4d46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1c4d46"]])

export default __exports__